import { gql } from 'apollo-boost';
const USER_QUERY_PART = `
{
    email
    createdAt
    googleId
    googleName
    googleProfilePic
    client {
        id
        name
        label
        namePostfix
    }
    role
}
`;
const mutationAuthUser = `
    mutation($code: String!, $authProvider: ProviderEnum!) {
        authorizeUser(authProvider: $authProvider, code: $code) {
            ok
            message
            accessExpiration
            user ${USER_QUERY_PART}
        }
    }
`;
const queryMe = `
    {
        me ${USER_QUERY_PART}
    }
`;
const GET_URLS_QUERY = gql `
	{
		authUrls {
			googleCode
			azureCode
		}
	}
`;
const createUser = gql `
	mutation ($email: String!, $role: String!) {
		createUser(email: $email, role: $role) {
			ok
		}
	}
`;
const deleteUser = gql `
	mutation ($email: String!, $role: String!) {
		deleteUser(email: $email, role: $role) {
			ok
		}
	}
`;
const changeRole = gql `
	mutation ($email: String!, $role: String!) {
		changeRole(email: $email, role: $role) {
			ok
		}
	}
`;
const getUsersQuery = gql `
	{
		users {
			email
			lastLoggedIn
			role
		}
	}
`;
export { queryMe, mutationAuthUser, GET_URLS_QUERY, createUser, getUsersQuery, changeRole, deleteUser };
